/* tslint:disable */
/* eslint-disable */
/**
 * 3DSurvey API
 * Frontend API for 3d Survey
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseData
 */
export interface ResponseData {
    /**
     * 
     * @type {boolean}
     * @memberof ResponseData
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResponseData
     */
    error: string;
    /**
     * 
     * @type {object}
     * @memberof ResponseData
     */
    data: object;
}

/**
 * Check if a given object implements the ResponseData interface.
 */
export function instanceOfResponseData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "success" in value;
    isInstance = isInstance && "error" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function ResponseDataFromJSON(json: any): ResponseData {
    return ResponseDataFromJSONTyped(json, false);
}

export function ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': json['success'],
        'error': json['error'],
        'data': json['data'],
    };
}

export function ResponseDataToJSON(value?: ResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
        'error': value.error,
        'data': value.data,
    };
}

